import { TestimonialService } from './../../common-theme/api/testimonial.service';
import { Component, OnInit } from '@angular/core';
import { Testimonial } from './../../common-theme/models/index';
import { OpenModalService } from '../../common-theme/base-components/shared/modals/open-modal.service';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})

export class TestimonialsComponent implements OnInit {
  myInterval: number = 5000;
  noWrapSlides: boolean = false;
  testimonials: Testimonial[] = [];

  constructor(
    private testimonialService: TestimonialService,
    private openModalService: OpenModalService
    ) { }

  ngOnInit(): void {
    this.testimonialService.getTestimonials()
        .then(testimonials => {
          this.testimonials = testimonials;
        });
  }

  openTestimonialModal(testimonial: Testimonial): void {
    this.openModalService.showTestimonialsContent(testimonial.author, testimonial.content);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/testimonials/testimonials.component.ts